// @ts-nocheck

import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';

const AnimationWrapper = styled.div`
  position: absolute;
  display: none;
  overflow: hidden;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  ${({ $animationTriggered }) =>
    $animationTriggered
      ? css`
          background-color: rgba(0, 0, 0, 0.7);
          border-radius: 1rem;
          z-index: 10;
          display: block;
        `
      : null}
`;

type MarchCardAnimationProps = {
  className?: string;
  Animations: unknown;
};

const MatchCardAnimation = ({ className, Animations }: MarchCardAnimationProps) => {
  const wrapperRef = useRef();
  const [animationTriggered, setAnimationTriggered] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const wrapperNode = wrapperRef.current;

    if (wrapperNode) {
      const parentNode = wrapperNode.parentNode;

      if (parentNode) {
        setDimensions((prev) => {
          if (prev.height !== parentNode.offsetHeight || prev.width !== parentNode.offsetWidth) {
            return {
              ...prev,
              width: parentNode.offsetWidth,
              height: parentNode.offsetHeight,
            };
          }

          return prev;
        });
      }
    }
  }, []);

  const onStart = useCallback(() => setAnimationTriggered(true), []);
  const onDone = useCallback(() => setAnimationTriggered(false), []);

  return (
    <AnimationWrapper ref={wrapperRef} className={className} $animationTriggered={animationTriggered}>
      <Animations width={dimensions.width} height={dimensions.height} onStart={onStart} onDone={onDone} />
    </AnimationWrapper>
  );
};

export default MatchCardAnimation;
